// src/constants/apiUrls.js
// ─────────────────────────────────────────────
// API 프록시 경로 상수 (단일 진입점)
// 실제 타겟 IP/도메인은 src/setupProxy.js 참고
// ─────────────────────────────────────────────


// 운영
export const BACK_OFFICE_API = "/adminApi";
export const LOGIN_API       = "/loginApi";
export const ORDER_API       = "/orderApi";
export const POS_API         = "/posApi";
export const ORDER_PROXY_API     = "/linkApi";
export const WEB_VERSION = "1.1.0";

// Prod 환경
export const NICE_CERT_ORIGIN = "https://login-api.ddingdongcorp.com";

// Dev 환경
// export const NICE_CERT_ORIGIN = "http://13.124.46.234:50002";

// ─────────────────────────────────────────────
// 하위 호환 alias
// 기존 import 유지용 — 추후 위 상수로 통일 예정
// ─────────────────────────────────────────────
export const adminApiUrl     = BACK_OFFICE_API;
export const loginApiUrl     = LOGIN_API;
export const orderApiUrl     = ORDER_API;
export const posApiUrl       = POS_API;
export const linkApiUrl      = ORDER_PROXY_API;
export const adminUrl        = BACK_OFFICE_API;
export const loginUrl        = LOGIN_API;
export const orderUrl        = ORDER_API;
export const posUrl          = POS_API;
export const outsideOrderUrl = ORDER_PROXY_API;

/**
 * ! @deprecated
 * setupProxy.js에 해당 IP 추적 불가능
 * Nginx 라우팅 확인 결과도 동일하게 해당 IP 추적 불가능
 * Nginx 라우팅에서 해당 경로 프록시 처리 안함.
 * @author Saccharin01
 * @since 2026-04-17
 */

// export const TEST_LOGIN_API = "/testLoginApi";
// export const TEST_ORDER_API = "/testOrderApi";
// export const TEST_POS_API   = "/testPosApi";
// export const TEST_LINK_API  = "/testLinkApi";
// export const NEW_TEST_API   = "/newTestApi";

// export const newTestApiUrl   = NEW_TEST_API;
// export const testLoginApiUrl = TEST_LOGIN_API;
// export const testOrderApiUrl = TEST_ORDER_API;
// export const testPosApiUrl   = TEST_POS_API;
// export const testLinkApiUrl  = TEST_LINK_API;

